export enum ClusteringMode {
  DYNAMIC = 'DYNAMIC',
  CLUSTERING_AREA = 'CLUSTERING_AREA'
}
